<template>
    <dialog
        v-show="showErrorMessage"
        class="block fixed w-full h-full p-4 z-50 top-0"
        style="background-color: rgba(0, 0, 0, 0.25)">
        <div class="relative w-full md:w-1/3 p-4 mx-auto bg-white" style="border-left: 10px solid red">
            <button class="tab-trap visually-hidden" v-on:focusin="tabtrap">Loopback</button>

            <div class="hx h2">Hoppsan, något gick fel!</div>
            <p>Något gick fel. Var god försök igen senare och om problemet kvarstår kontakta kundtjänst.</p>
            <div v-show="errorMessage" class="bg-gray-100 p-2">{{ errorMessage }}</div>
            <button class="close-btn absolute top-0 right-0 p-4" @click="hideError">×</button>

            <button class="tab-trap visually-hidden" v-on:focusin="tabtrap">Loopback</button>
        </div>
    </dialog>
</template>

<script>
import { promptStore } from '../../stores/prompt';
import { mapState, mapActions } from 'pinia';

export default {
    name: 'ErrorPrompt',

    computed: {
        ...mapState(promptStore, {
            showErrorMessage: 'showErrorMessage',
            errorMessage: 'errorMessage',
        }),
    },

    methods: {
        ...mapActions(promptStore, ['hideError']),

        tabtrap(event) {
            event.target
                .closest('dialog')
                .querySelectorAll(
                    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])'
                )[1]
                .focus();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.close-btn {
    font-size: 1.875rem;
    line-height: 0.5;
}
</style>
